import React from 'react'
import { array, func } from 'prop-types'
import { Input, Button } from 'antd'
import {
	MinusCircleOutlined,
	PlusOutlined,
	LockOutlined,
	UnlockOutlined,
} from '@ant-design/icons'

import { FormItem, ListItem } from './styles'

export const WidgetOption = ({ options, update }) => {
	options = options ?? []

	const addOption = () => {
		let newOption = { label: '', value: '' }
		update({ options: [...options, newOption] })
	}

	const removeOption = (index) => {
		update({ options: options.filter((x, i) => i !== index) })
	}

	const updateOption = (property, value, index) =>
		update({
			options: [
				...options.slice(0, index),
				{ ...options[index], [property]: value },
				...options.slice(index + 1),
			],
		})

	const toggleDisabled = (index) => {
		const newDisabledState = !options[index]?.disabled
		updateOption('disabled', newDisabledState, index)
	}

	return (
		<>
			<FormItem label="Opções">
				{options.map((option, i) => (
					<ListItem key={option.value + i}>
						<Input.Group compact>
							<Input
								placeholder="Título"
								style={{ width: '50%' }}
								defaultValue={option.label}
								onBlur={(e) => updateOption('label', e.target.value, i)}
							/>

							<Input
								placeholder="Valor"
								style={{ width: '50%' }}
								defaultValue={option.value}
								onBlur={(e) => updateOption('value', e.target.value, i)}
							/>
						</Input.Group>

						{option.disabled ? (
							<LockOutlined
								onClick={() => toggleDisabled(i)}
								style={{ color: 'gray', padding: '0 10px', cursor: 'pointer' }}
							/>
						) : (
							<UnlockOutlined
								onClick={() => toggleDisabled(i)}
								style={{ color: 'green', padding: '0 10px', cursor: 'pointer' }}
							/>
						)}

						<MinusCircleOutlined
							onClick={() => removeOption(i)}
							style={{ padding: '0 10px' }}
						/>
					</ListItem>
				))}

				<FormItem>
					<Button
						type="dashed"
						onClick={() => addOption()}
						block
						icon={<PlusOutlined />}>
						Adicionar
					</Button>
				</FormItem>
			</FormItem>
		</>
	)
}

WidgetOption.propTypes = {
	options: array,
	update: func,
}
